// extracted by mini-css-extract-plugin
module.exports = {"calc_solarpanel":"solarpanels_calc_solarpanel__W3NfE"};